import React from 'react';

function PoiDescription({ descriptions }) {
    const description = descriptions.find((d) => d.type === 'manual') || descriptions.find((d) => d.type === 'auto');
    return (
        <div
            className="poi-description space-y-3 max-w-3xl mt-2"
            dangerouslySetInnerHTML={{ __html: description?.content }}
        />
    );
}

PoiDescription.propTypes = {};

export default PoiDescription;
